import React, { useEffect, useState, Fragment, useRef } from "react";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

export default class ComponentToPrint extends React.Component {
    render() {
        const data = this.props.data;
        const deductionTypeNamesOfTable = this.props.deductionTypeNamesOfTable;
        const searchData = this.props.searchData;
        const colName = this.props.initialData;
        const summeryValues = this.props.summeryValues;
        const summeryData = this.props.summeryData;
        return (
            <div className="p-2">
                <h3><center><u>BL Factory Weigh Detail Report</u></center></h3>
                <div className="row pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Operation Entity: </b> {searchData.operationEntity}</div>
                    <div className="col"><b>Collection Point: </b> {searchData.collectionPoint}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                </div>
                <TableContainer component={Paper}>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>Tag Number</TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                    Date
                                </TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                    Time
                                </TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                    Bag Count
                                </TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                    Actual Amount
                                </TableCell>
                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                    Gross Amount
                                </TableCell>
                                {deductionTypeNamesOfTable.map((item) => (
                                    <TableCell style={{ fontWeight: "bold" }} align='center'>{item}</TableCell>
                                ))}
                                <TableCell align="center" style={{ fontWeight: "bold" }}>
                                    Net Amount
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map((row) => (
                                <TableRow key={row.employeeCode}>
                                    <TableCell component="th" scope="row">
                                        {row.ftagNumber}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {row.ffullTime}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {row.fstartTime}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {row.count}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {row.factualAmount}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {row.fGrossAmount}
                                    </TableCell>

                                    {deductionTypeNamesOfTable.map((column) => {
                                        const value = row[column];
                                        return (
                                            <TableCell align='right'>{value == undefined ? '-' : value}</TableCell>
                                        );
                                    })}
                                    <TableCell align="center">{parseInt(row.fNetAmount)}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <TableBody>
                            <TableRow>
                                <TableCell colSpan={3} style={{ fontWeight: "bold" }} align="left">
                                    Total
                                </TableCell>
                                <TableCell style={{ fontWeight: "bold" }} align="left">
                                    {summeryValues.bagTot}
                                </TableCell>
                                <TableCell style={{ fontWeight: "bold" }} align="left">
                                    {parseFloat(summeryValues.actualTot).toFixed(2)}
                                </TableCell>
                                <TableCell style={{ fontWeight: "bold" }} align="left">
                                    {parseFloat(summeryValues.grossTot).toFixed(2)}
                                </TableCell>
                                {deductionTypeNamesOfTable.map((item) => {
                                    var result = summeryData.find(y => y.name === item);
                                    return (
                                        <TableCell style={{ fontWeight: "bold" }} align='right'>{result == undefined ? parseFloat(0).toFixed(2) : parseFloat(result.value).toFixed(2)}</TableCell>
                                    );
                                })}
                                <TableCell style={{ fontWeight: "bold" }} align="center">
                                    {parseInt(summeryValues.netTot)}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        );
    }
}


